export const environment = {
	production: false,
	firebase: {
		config: {
			projectId: 'thecoffeebaradev',
			appId: '1:668660360266:web:128ddde13797f8c5c332b3',
			storageBucket: 'thecoffeebaradev.firebasestorage.app',
			apiKey: 'AIzaSyCZ9ZNF-Zy4Z6NIObGuucD9UN2sYt4OSak',
			authDomain: 'thecoffeebaradev.firebaseapp.com',
			messagingSenderId: '668660360266',
			measurementId: 'G-WRRMQTBBSK',
		},
		vapidKey:
			'BDF4o596HtWNxo1XJPdyBluCNkUmvhOW2WYxe-XNA4m8lMYzviAlu8JKqCK_yDIFyYUGBtDY_hlk3jXehUxqnEM',
		recaptchaKey: '6LeZozIrAAAAADZ92qC8OKyPqBdtLfm3gY5G8Ke3',
		dt: '7ab427ae-25e9-470a-9807-0d493eecea09',
	},
	api_url: 'https://us-central1-thecoffeebaradev.cloudfunctions.net/api',
	// api_url: 'http://localhost:5001/thecoffeebaradev/us-central1/api',
	companyId: '9gn6Zr432IHaBoxLcHxS',
};
